import type { PlanImage } from './woodworking'

const IMG = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/6c1a724c-31a4-442a-bc25-af15f66c889e/'

export interface PainCard extends PlanImage {
  title: string
  line: string
}

/** Three garage-welder pains, each with a real shop photo. */
export const PAIN_CARDS: PainCard[] = [
  { src: `${IMG}1793811958926_pain-guess-5b3a6f81.webp`, title: 'Guessing measurements', line: 'Most plans online are a photo and a guess.', alt: 'Frustrated welder in his garage, holding his head over a pile of steel tube', width: 800, height: 600 },
  { src: `${IMG}1793811963844_pain-scrap-17273970.webp`, title: 'Steel in the scrap pile', line: 'One wrong cut and the bar is wasted.', alt: 'Pile of badly cut steel pieces under a chop saw', width: 800, height: 600 },
  { src: `${IMG}1793811970491_pain-idle-a3c4c1d4.webp`, title: 'A welder under a tarp', line: 'You can weld—you just don’t know what sells.', alt: 'Welder covered with a dusty tarp in a garage', width: 800, height: 600 },
]
